export default {"src":"/_next/static/media/sad.5b54a961.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};